<template>
  <div
    v-if="showElement"
    class="compare-row margin-bottom-xs tablet:margin-bottom-0"
  >
    <dl class="row roomy padding-x-2xs">
      <table-feature-name
        :feature-name="featureName"
        :feature-description="featureDescription"
        :feature-icon="featureIcon"
      />
      <div class="column-12 tablet:column-9 laptop:column-10 display-flex padding-x-2xs tablet:padding-x-sm">
        <table-feature-status
          v-for="sku in plansBySku"
          :key="sku"
          :plan="planBySku(sku)"
          :handle-function="handleFunction"
        />
      </div>
    </dl>
  </div>
</template>

<script>
  import TableFeatureStatus from './TableFeatureStatus'
  import TableFeatureName from './TableFeatureName'

  export default {
    name: 'PlanCompareTable',

    components: {
      TableFeatureStatus,
      TableFeatureName
    },

    props: {
      featureName: {
        type: String
      },
      featureIcon: {
        type: String
      },
      featureDescription: {
        type: String
      },
      featureIncluded: {
        type: String
      },
      featureDetails: {
        type: String
      },
      plansBySku: {
        type: Array
      },
      currentPlans: {
        type: Array
      },
      handleFunction: {
        type: Function
      },
      showElement: {
        type: Boolean,
        default: true
      }
    },

    methods: {
      planBySku(sku) {
        if (this.currentPlans.length > 0) {
          return this.currentPlans.find((plan) => plan.sku == sku)
        } else {
          return {}
        }
      }
    }
  }
</script>
